import { render, staticRenderFns } from "./Manufacturer.vue?vue&type=template&id=160ded90&"
import script from "./Manufacturer.vue?vue&type=script&lang=js&"
export * from "./Manufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports